export class UpdateEntitlement {
    username = "";
    authToken = "";
    entitlementid = "";
    currentaccountid = "";
    newaccountid = "";
    entitlementstateid = 0;
    updatereason = "";
    creationbatchid = 0;
}